import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Detail_Textual_10_scale({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Find the hit range to display on the right
  const hitRange = item.scale.ranges.find((range) => range.isHit);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Calculate which scale position (1-10) the score falls into
  // Score is 0-100, so divide by 10 and round up
  const scalePosition = Math.ceil(elementScore / 10) || 1; // Ensure minimum value of 1

  // Generate the 10 scale boxes
  const renderScaleBoxes = () => {
    const boxes = [];
    for (let i = 1; i <= 10; i++) {
      const isActive = i === scalePosition;
      const borderColor = rgbEnabled ? colors.primary : "#4a90e2";

      boxes.push(
        <div
          key={i}
          style={{
            width: "45px",
            height: "35px",
            borderTop: `2px solid ${borderColor}`,
            borderBottom: `2px solid ${borderColor}`,
            borderLeft: i === 1 ? `2px solid ${borderColor}` : "none",
            borderRight: `2px solid ${borderColor}`,
            backgroundColor: isActive ? (rgbEnabled ? colors.primary : "#4a90e2") : "#ffffff",
            color: isActive ? "#ffffff" : rgbEnabled ? colors.dark : "#333333",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "600",
            borderTopLeftRadius: i === 1 ? "6px" : "0",
            borderBottomLeftRadius: i === 1 ? "6px" : "0",
            borderTopRightRadius: i === 10 ? "6px" : "0",
            borderBottomRightRadius: i === 10 ? "6px" : "0",
          }}
        >
          {i}
        </div>
      );
    }
    return boxes;
  };

  return (
    <Row style={{ height: Number(item.height), marginBottom: "2px" }}>
      <div className="p-1" style={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}>
        {/* Main layout */}
        <Row className="align-items-stretch">
          {/* Left side - Scope name and Item name with ten scale */}
          <Col xs={5} style={{ minHeight: "150px" }}>
            {/* Scope name (only if isSub) */}

            {/* Item name */}
            <div
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: rgbEnabled ? colors.dark : "#333",
                marginBottom: "5px",
              }}
            >
              {item.name}
              {!item.isSub && item.scopeName && (
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: "600",
                    color: "#acacacff",
                    textTransform: "uppercase",
                    marginLeft: "8px",
                  }}
                >
                  ({item.scopeName})
                </span>
              )}
            </div>

            {/* Ten scale boxes */}
            <div style={{ display: "flex", flexDirection: "row" }}>{renderScaleBoxes()}</div>
          </Col>

          {/* Right side - Hit range text */}
          <Col xs={7} className="pe-4">
            {hitRange && (
              <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
                {item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange.text }} /> : hitRange.text}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
